import { Box, Button, Stack, Typography } from '@mui/joy'
import { useApi } from 'api'
import { useOrgIntegrationsApi } from 'apiProviders'
import Loading from 'components/Loading'
import { useOrgId } from 'helpers'
import { useState } from 'react'

const Zoho = () => {
    const { VITE_ZOHO_CLIENT_ID, VITE_APP_EXTERNAL_API_URL } = import.meta.env
    const api = useApi()
    const orgId = useOrgId()
    const integrationsApi = useOrgIntegrationsApi()

    const [loading, setLoading] = useState(false)

    const zoho = integrationsApi.data?.zoho

    const redirect_uri = `${VITE_APP_EXTERNAL_API_URL}/zoho/authredirect`

    console.log({
        VITE_ZOHO_CLIENT_ID,
        VITE_APP_EXTERNAL_API_URL,
        redirect_uri,
    })

    return (
        <Box>
            <Stack gap={2}>
                <Box sx={{ height: '120px', width: '120px' }}>
                    <img
                        src="https://www.zoho.com/sign/images/zoho-sign-logo.png"
                        style={{ height: '120px', width: '120px', objectFit: 'contain' }}
                        alt="Zoho Sign Logo"
                    />
                </Box>
                <Box>
                    {zoho ? (
                        <>
                            <Typography>Connected to Zoho Sign</Typography>
                            <Button
                                sx={{ mt: 2 }}
                                variant="outlined"
                                color="danger"
                                loading={loading}
                                onClick={async () => {
                                    setLoading(true)
                                    await api.delete('/zoho')
                                    await integrationsApi.refresh()
                                    setLoading(false)
                                }}
                            >
                                Disconnect
                            </Button>
                        </>
                    ) : (
                        <Button
                            loading={loading}
                            onClick={() => {
                                setLoading(true)
                                const queryData = new URLSearchParams({
                                    response_type: 'code',
                                    client_id: VITE_ZOHO_CLIENT_ID,
                                    scope: 'ZohoSign.documents.ALL,ZohoSign.templates.ALL,ZohoSign.account.READ',
                                    redirect_uri,
                                    state: orgId!,
                                    access_type: 'offline',
                                    prompt: 'consent',
                                })
                                window.location.href = `https://accounts.zoho.com.au/oauth/v2/auth?${queryData.toString()}`
                            }}
                        >
                            Connect
                        </Button>
                    )}
                </Box>
            </Stack>
        </Box>
    )
}

export default () => {
    const integrationsApi = useOrgIntegrationsApi()

    if (!integrationsApi.data) return <Loading />

    return <Zoho />
}
